import { transformGamesWithJoinedOdds } from "../../services/UserGroup.js";
import { APP_CONFIG } from "../constants/global-variables.js";

export async function getPrematchGamesMainLeague() {
    const options = {
        method: "GET",
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/prematchgamesmainleague`;

    try {
        const res = await axios.post(url, {});

        return transformGamesWithJoinedOdds(res.data);
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}
